import { gsap } from "gsap";

import { AbstractGameMode } from "../../../../../abstracts/flow/AbstractGameMode";
import { AbstractView } from "../../../../../abstracts/modules/AbstractView";
import { ApocalypseSoundNames } from "../../../../assetsLoader/ApocalypseAssetsNames";
import { ApocalypseFreespinIntroScreen } from "./ApocalypseFreespinIntroScreen";

export class ApocalypseFreespinRestoreScreen extends ApocalypseFreespinIntroScreen {
    constructor(parentContainer: AbstractView, name: string = `ApocalypseFreespinRestoreScreen`) {
        super(parentContainer, name);
    }

    public override getGsapAnimation(
        fsLeft: number = 0,
        gameMode: AbstractGameMode = AbstractGameMode.FREESPIN
    ): gsap.core.Timeline {
        this.customText.updateSpinsLeftText(fsLeft);

        const tl = gsap.timeline({
            autoRemoveChildren: true,
            smoothChildTiming: true,
            onStart: () => {
                this.addChild(this.customText);
            },
        });

        const spineAnimationTL = gsap.timeline({
            autoRemoveChildren: true,
            smoothChildTiming: true,
        });

        const spineAnimation = this.mainSpine.getSpineTween(`intro`);
        spineAnimationTL.add(spineAnimation, 0);
        spineAnimationTL.to({}, { duration: 0.01 }, `end`);

        tl.add(spineAnimationTL.seek(`end`, false), 0);

        tl.add(this.customText.getAnimation(false, gameMode), 0);

        tl.call(
            () => {
                this.addChild(this.continueButton);
            },
            undefined,
            `>-0.3`
        );

        return tl;
    }

    protected getIntroLoopSoundName(): string {
        return ApocalypseSoundNames.FS_INTRO_LOOP;
    }
}
